"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.regexp.to-string");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
var _typeof2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.find");
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _elementUi = require("element-ui");
var _gOption = _interopRequireDefault(require("./gOption"));
var _types = require("element-ui/lib/utils/types");
var _util = require("element-ui/lib/utils/util");
var _listenScroll = require("./mixins/listenScroll");
var _focusOnClear = require("./mixins/focusOnClear");
var _associateService = _interopRequireDefault(require("./associateService"));
var _utils = require("./utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { t } from 'element-ui/lib/locale';

var remoteMethod = function remoteMethod(val) {
  var _this = this;
  var keyword = this.formatKeyword(val || '');
  if (keyword.length < this.queryLength) {
    return;
  }
  this.previousKeyword = keyword;
  this.lastSearchId++;
  var lastSearchId = this.lastSearchId;
  this.searching = true;
  var trim = this.trim;
  var dbc = this.dbc;
  var _case = this.case;
  var pageSize = this.pageSize;
  var currentPage = this.currentPage || 1;
  var currentTab = this.currentTab;
  this.previousQuery = keyword;
  this.queryMethod({
    originKeyword: val,
    keyword: keyword,
    currentTab: currentTab,
    pageSize: pageSize,
    currentPage: currentPage,
    trim: trim,
    dbc: dbc,
    case: _case
  }).then(function (result) {
    // 不是最后一次搜索返回的结果，直接丢弃
    if (_this.lastSearchId !== lastSearchId) {
      return;
    }
    var records = result[_this.recordsKey],
      total = result[_this.totalKey],
      fromIndex = result[_this.fromKey],
      toIndex = result[_this.toKey];
    var list = records || [];
    if (_this.allowCreate && keyword && (_this.allowCreateWhenNotEmpty || !list.length)) {
      var createdItem = _this.createMethod ? _this.createMethod(keyword) : (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, _this.valueProp, keyword), _this.labelProp, keyword), "__isCreated", true);
      if (!list.find(function (item) {
        return item[_this.valueProp] === createdItem[_this.valueProp];
      })) {
        list.push(createdItem);
      }
    }
    _this.list = list;
    _this.total = total;
    // this.fromIndex = fromIndex;
    // this.toIndex = toIndex;
    _this.fromIndex = (currentPage - 1) * pageSize;
    _this.toIndex = _this.fromIndex + _this.list.length - 1;
    _this.$nextTick(function () {
      return _this.sortOptions();
    });
    if (!_this.userSelect && !_this.visible) {
      _this.onlyOneSelect();
    }
  }).catch(function (e) {
    window.console.error(e);
  }).finally(function () {
    if (_this.lastSearchId !== lastSearchId) {
      return;
    }
    _this.userSelect = false;
    _this.searching = false;
  });
};
var _default2 = exports.default = {
  name: 'ElAssociate',
  components: {
    GOption: _gOption.default
  },
  extends: _elementUi.Select,
  mixins: [_listenScroll.listenScrollMixin, _focusOnClear.focusOnClearMixin],
  props: {
    /** 联想控件必须开启输入 */
    filterable: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        if (!val) {
          window.console.error('`Filterable` prop in <gl-associate> must be `true`.');
          return false;
        }
        return true;
      }
    },
    /** 联想控件必须开启远程搜索 */
    remote: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        if (!val) {
          window.console.error('`Remote` prop in <gl-associate> must be `true`.');
          return false;
        }
        return true;
      }
    },
    allowCreate: {
      type: Boolean,
      default: false
      // validate(val) {
      //   if (val) {
      //     window.console.error(
      //       '`AllowCreate` prop in <gl-associate> must be `false`.'
      //     );
      //     return false;
      //   }
      //   return true;
      // }
    },
    /** 是否允许在有返回值的情况下新建条目 */
    allowCreateWhenNotEmpty: {
      type: Boolean,
      default: function _default() {
        return this.$ELEMENT && this.$ELEMENT.config && this.$ELEMENT.config.associate && this.$ELEMENT.config.associate.allowCreateWhenNotEmpty || false;
      }
    },
    /** 焦点进入时是否保持输入框的文字，只对单选有效 */
    keepInputValue: {
      type: Boolean,
      default: function _default() {
        return this.$ELEMENT && this.$ELEMENT.config && this.$ELEMENT.config.associate && this.$ELEMENT.config.associate.keepInputValue || false;
      }
    },
    /** 是否焦点进入的时候以输入框的文本进行查询。单选且开启 keepInputValue 时有效 */
    initSearchKeepValue: {
      type: Boolean,
      default: function _default() {
        return this.$ELEMENT && this.$ELEMENT.config && this.$ELEMENT.config.associate && this.$ELEMENT.config.associate.initSearchKeepValue || false;
      }
    },
    /** 自定义无匹配数据时如何创建记录项 */
    createMethod: {
      type: Function,
      default: null
    },
    /** 是否默认选择第一行，可统一配置 */
    defaultFirstOption: {
      type: Boolean,
      default: function _default() {
        return this.$ELEMENT && this.$ELEMENT.config && this.$ELEMENT.config.associate && this.$ELEMENT.config.associate.defaultFirstOption || false;
      }
    },
    popperAppendToBody: {
      type: Boolean,
      default: function _default() {
        var configValue = this.$ELEMENT && this.$ELEMENT.config && this.$ELEMENT.config.associate && this.$ELEMENT.config.associate.popperAppendToBody;
        return configValue === undefined ? true : configValue;
      }
    },
    /** 下拉列表显示的表格列信息
     * - `column.title` 列标题
     * - `column.field` 列字段
     * - `column.format` 格式化显示方法，选填
     */
    columns: {
      type: Array,
      required: true
    },
    /** 值字段，必输 */
    valueProp: {
      type: String,
      required: true
    },
    /** 显示字段，或不配置则与 `labelProp` 相同 */
    labelProp: String,
    /** 是否显示表头 */
    showColumnHeader: {
      type: Boolean,
      default: true
    },
    /** 请求延迟时间 */
    delayTime: {
      type: Number,
      default: 300
    },
    /** remoteMethod 不可配置 */
    remoteMethod: {
      type: Function,
      default: remoteMethod,
      validator: function validator(val) {
        if (val !== remoteMethod) {
          return false;
        }
        return true;
      }
    },
    /** 用户需配置 queryMethod，返回 Promise */
    queryMethod: {
      type: Function,
      required: true
    },
    /** queryMethod 返回的数据字段 */
    recordsKey: {
      type: String,
      default: 'records'
    },
    /** queryMethod 返回的数据从序号字段 */
    fromKey: {
      type: String,
      default: 'recordStart'
    },
    /** queryMethod 返回的数据到序号字段 */
    toKey: {
      type: String,
      default: 'recordEnd'
    },
    /** queryMethod 返回的数据总条数字段 */
    totalKey: {
      type: String,
      default: 'total'
    },
    /** 每页记录数 */
    pageSize: {
      type: Number,
      default: 10
    },
    /** 为联想控件赋初始值，回显需要设置的字符串，与 `v-model` 的值一一对应 */
    displayInit: {
      type: [String, Array]
    },
    /** 请求关键字长度，当关键字长度小于此设置时，不请求查询 */
    queryLength: {
      type: Number,
      default: 0
    },
    /** 查询关键字是否全角转半角 */
    dbc: Boolean,
    /** 查询关键字是否去空格：
     *  - `ltrim`：去除左边空格；
     *  - `rtrim`：去除右边空格；
     *  - `atrim`：去除全部空格；
     *  - `trim`：去除左右空格
     */
    trim: String,
    /**
     * 查询关键字是否转换大小写
     * - `upper`: 转大写
     * - `lower`: 转大写
     */
    case: String,
    /**
     * 绑定关联字段值
     * key 为绑定的父组件 data 值, value 为对应组件列表数据的 key 值
     */
    dataBind: Object,
    autoSelectOnlyOption: {
      type: Boolean,
      default: function _default() {
        var configValue = this.$ELEMENT && this.$ELEMENT.config && this.$ELEMENT.config.associate && this.$ELEMENT.config.associate.autoSelectOnlyOption;
        return configValue === undefined ? true : configValue;
      }
    },
    /** 是否禁止在已显示下拉面板时，再次点击输入框收起下拉面板 */
    disableClickHideMenu: {
      type: Boolean,
      default: function _default() {
        return this.$ELEMENT && this.$ELEMENT.config && this.$ELEMENT.config.associate && this.$ELEMENT.config.associate.disableClickHideMenu || false;
      }
    },
    /** 是否入焦点的时候选中文本框的文字 */
    focusSelect: {
      type: Boolean,
      default: function _default() {
        return this.$ELEMENT && this.$ELEMENT.config && this.$ELEMENT.config.associate && this.$ELEMENT.config.associate.focusSelect || false;
      }
    },
    /** AssociateService 对应的 key 值 */
    serviceKey: String,
    /** 格式化联想控件显示，可使用 {{}} 表达式字符串或 function，接收参数 record */
    displayFormat: [String, Function],
    /** 过滤联想控件tabList，以[{label: label, value: value}]形式入参，默认[] */
    filterTabList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /** 过滤联想控件tabList默认值 */
    defaultFilterTab: {
      type: String,
      default: ''
    },
    /** 是否展示分页 */
    showPage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      /** 下拉列表数据集合 */
      list: [],
      /** 列表记录从 */
      fromIndex: null,
      /** 列表记录到 */
      toIndex: null,
      /** 总记录数 */
      total: null,
      /** 当前页 */
      currentPage: 1,
      /** 选中的列表项 */
      selectItem: null,
      /** 最后一次发起搜索的 id */
      lastSearchId: 0,
      /** 是否加载状态 */
      searching: false,
      /** 是否用户选择 */
      userSelect: false,
      /** 是否用户按下 Esc */
      esc: false,
      /** 前一次搜索关键字 */
      previousKeyword: null,
      /** 当前tab对象*/
      currentTab: '',
      /** 当前船型*/
      selectAll: false
    };
  },
  computed: {
    /**
     * 搜索延迟时间
     * @returns {number}
     */
    debounce: function debounce() {
      return this.delayTime || 300;
    },
    /**
     * 是否可以向下翻页
     * @returns {boolean}
     */
    canNextPage: function canNextPage() {
      if (this.hasTotal) {
        return this.toIndex + 1 < this.total;
      }
      return this.list.length >= this.pageSize;
    },
    /**
     * 是否可以向上翻页
     * @returns {boolean}
     */
    canPrevPage: function canPrevPage() {
      return this.currentPage > 1;
    },
    /**
     * 无数据显示文字
     * @returns {string}
     */
    emptyText: function emptyText() {
      if (this.searching) {
        return this.loadingText || this.t('el.select.loading');
      } else {
        if (this.options.length === 0) {
          return this.noDataText || this.t('el.select.noData');
        }
      }
      return null;
    },
    iconClass: function iconClass() {
      return 'search is-reverse';
    },
    /**
     * 是否有统计总条数
     * @returns {boolean}
     */
    hasTotal: function hasTotal() {
      return typeof this.total === 'number';
    },
    /**
     * 下拉面板显示的总条数文字
     * @returns {string}
     */
    totalText: function totalText() {
      return this.t('el.associate.totalFormat', {
        total: this.total
      });
    },
    /**
     * 下拉面板显示的记录起止文字
     * @returns {string}
     */
    fromToText: function fromToText() {
      var length = this.list.length;
      var from = length ? this.fromIndex + 1 : '';
      var to = length ? this.toIndex + 1 : '';
      return this.t('el.associate.fromToFormat', {
        from: from,
        to: to
      });
    },
    displayFormatFunc: function displayFormatFunc() {
      var displayFormat = this.displayFormat;
      switch ((0, _typeof2.default)(displayFormat)) {
        case 'function':
          return displayFormat;
        case 'string':
          return function (data) {
            return displayFormat.replace(/\{([\s\S]+?)\}/g, function ($0, $1) {
              return new Function('row', "return ".concat($1, " || ''"))(data || {});
              // return 'aaa';
            });
          };
        default:
          return null;
      }
    }
  },
  watch: {
    visible: function visible(val) {
      this.currentTab = JSON.parse(JSON.stringify(this.defaultFilterTab));
      if (!val) {
        // 焦点移开的时候触发查询
        var input = this.$refs.input || this.$refs.reference;
        var query = input && input.value;
        if (query && query !== this.previousKeyword) {
          this.remoteMethod(query);
        }
        this.currentPage = 1;
        if (!this.searching && !this.userSelect) {
          this.onlyOneSelect();
        }
      } else {
        this.list = [];
        this.currentPage = 1;
        this.total = 0;
        this.fromIndex = 0;
        this.toIndex = 0;
        this.userSelect = false;
        this.esc = false;
        if (!this.multiple && this.keepInputValue) {
          var _input = this.$refs.input || this.$refs.reference;
          this.selectedLabel = _input && _input.value || '';
          if (this.initSearchKeepValue) {
            this.query = this.selectedLabel;
          }
        }
        this.remoteMethod(this.query);
      }
    },
    query: function query() {
      // 搜索关键字改变时，当前页码重置为 1
      this.currentPage = 1;
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!this.serviceKey) {
              _context.next = 5;
              break;
            }
            _context.next = 3;
            return _associateService.default.getData(this.serviceKey);
          case 3:
            this.serviceData = _context.sent;
            this.setSelected();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    /**
     * 获取表格列显示文本
     * @param {*} record 当前行的数据
     * @param {*} column 列对象
     * @returns {string}
     */
    getColumnDisplay: function getColumnDisplay(record, column) {
      var field = column.field,
        format = column.format;
      var value = record && record[field];
      if ((0, _types.isFunction)(format)) {
        return format(value);
      }
      return value;
    },
    /**
     * 获取表格列的样式（宽度）
     * @param {*} column 列对象
     * @returns {*}
     */
    getColumnStyle: function getColumnStyle(column) {
      return {
        width: column.width,
        maxWidth: column.width,
        textAlign: column.align || 'left'
      };
    },
    handleSelectAll: function handleSelectAll(val) {
      var _this2 = this;
      if (val) {
        this.selected = [];
        var _iterator = (0, _createForOfIteratorHelper2.default)(this.list),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            this.selected.push(this.getOption(item[this.valueProp]));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var value = this.list.map(function (v) {
          return v[_this2.valueProp];
        });
        this.$emit('input', value);
        this.emitChange(value);
      } else {
        this.selected = [];
        this.$emit('input', []);
        this.emitChange([]);
      }
    },
    /**
     * 判断是否勾选行
     * @param {*} record 行数据
     * @returns {boolean}
     */
    isSelectedRow: function isSelectedRow(record) {
      var option = this.getOption(record[this.valueProp]);
      return option && option.itemSelected;
    },
    /** 下一页 */nextPage: function nextPage() {
      if (this.canNextPage) {
        this.currentPage++;
        this.remoteMethod(this.query);
      }
      this.setSoftFocus();
    },
    /** 上一页 */prevPage: function prevPage() {
      if (this.canPrevPage) {
        this.currentPage--;
        this.remoteMethod(this.query);
      }
      this.setSoftFocus();
    },
    handleTabClick: function handleTabClick(val) {
      this.currentPage = 1;
      this.remoteMethod(this.query);
      this.setSoftFocus();
    },
    /**
     * 重写 getOption 方法，赋初始值时，根据回显示值 `displayInit` 进行显示
     */
    getOption: function getOption(value) {
      var _this3 = this;
      var option;
      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';
      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
        var cachedOption = this.cachedOptions[i];
        var isEqual = isObject ? (0, _util.getValueByPath)(cachedOption.value, this.valueKey) === (0, _util.getValueByPath)(value, this.valueKey) : cachedOption.value === value;
        if (isEqual) {
          option = cachedOption;
          break;
        }
      }
      if (option) return option;
      var newOption;
      if (this.serviceData && this.serviceData.length) {
        var record = this.serviceData.find(function (item) {
          return item[_this3.valueProp] === value;
        });
        if (record) {
          newOption = {
            value: value,
            currentLabel: this.displayFormatFunc ? this.displayFormatFunc(record) : record[this.labelProp],
            data: record
          };
        }
      }
      if (!newOption) {
        var label = !isObject && !isNull && !isUndefined ? this.getLabelInit(value) : '';
        var _record = (0, _defineProperty2.default)((0, _defineProperty2.default)({}, this.valueProp, value), this.labelProp, label);
        newOption = {
          value: value,
          currentLabel: label,
          data: _record
        };
      }
      if (this.multiple) {
        newOption.hitState = false;
      }
      return newOption;
    },
    /**
     * 获取初始回显文本
     * @param {string} value
     * @returns {string}
     */
    getLabelInit: function getLabelInit(value) {
      if (this.multiple) {
        var valueIndex = (this.value || []).findIndex(function (v) {
          return v === value;
        });
        return (this.displayInit || [])[valueIndex] || value;
      }
      if (!value) {
        return '';
      }
      return this.displayInit || value;
    },
    /**
     * 格式化关键字
     * @param {string} val
     * @returns {string}
     */
    formatKeyword: function formatKeyword(val) {
      var result = val;
      if (this.trim) {
        result = (0, _utils.trim)(result, this.trim);
      }
      if (this.case) {
        result = (0, _utils.changeCase)(result, this.case);
      }
      if (this.dbc) {
        result = (0, _utils.toCDB)(result);
      }
      return result;
    },
    /**
     * 重写 setSelected 方法
     */
    setSelected: function setSelected() {
      var _this4 = this;
      this.userSelect = true;
      if (!this.multiple) {
        var option = this.getOption(this.value);
        if (option.created) {
          this.createdLabel = option.currentLabel;
          this.createdSelected = true;
        } else {
          this.createdSelected = false;
        }
        this.selectedLabel = option.currentLabel;
        this.selected = option;
        if (this.filterable) this.query = this.selectedLabel;
        return;
      }
      var result = [];
      if (Array.isArray(this.value)) {
        this.value.forEach(function (value) {
          result.push(_this4.getOption(value));
        });
      }
      this.selected = result;
      this.$nextTick(function () {
        _this4.resetInputHeight();
      });
    },
    /** 当只有一条记录的时候，选中 */onlyOneSelect: function onlyOneSelect() {
      if (!this.autoSelectOnlyOption || this.list.length !== 1 || this.esc) {
        return;
      }
      var value = this.list[0][this.valueProp];
      var option = this.getOption(value);
      this.handleOptionSelect(option, false, true);
    },
    /** 重写 checkDefaultFirstOption 方法 */checkDefaultFirstOption: function checkDefaultFirstOption() {
      if (this.options.length) {
        this.hoverIndex = 0;
      } else {
        this.hoverIndex = -1;
      }
    },
    /** 重写 handleOptionSelect 方法,
     * 添加参数 isOnlyOneSelect，当为 true 时，不执行 setSoftFocus，多选不移除已选项
     */
    handleOptionSelect: function handleOptionSelect(option, byClick, isOnlyOneSelect) {
      if (this.multiple) {
        var value = (this.value || []).slice();
        var optionIndex = this.getValueIndex(value, option.value);
        if (optionIndex > -1) {
          if (isOnlyOneSelect) {
            return;
          }
          value.splice(optionIndex, 1);
        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
          value.push(option.value);
        }
        this.$emit('input', value);
        this.emitChange(value);
        if (option.created) {
          this.query = '';
          this.handleQueryChange('');
          this.inputLength = 20;
        }
        if (this.filterable && !isOnlyOneSelect) this.$refs.input.focus();
      } else {
        this.$emit('input', option.value);
        this.emitChange(option.value);
        this.visible = false;
      }
      this.isSilentBlur = byClick;
      if (!isOnlyOneSelect) {
        this.setSoftFocus();
      }
      if (this.visible) return;
      // this.$nextTick(() => {
      //   this.scrollToOption(option);
      // });
    },
    /** 重写 emitChange 方法 */emitChange: function emitChange(val) {
      var _this5 = this;
      if (!(0, _util.valueEquals)(this.value, val)) {
        var selectedRows = this.multiple ? (val || []).map(function (v) {
          return _this5.getRecordData(v);
        }) : this.getRecordData(val);
        this.$emit('change', val, selectedRows);
      }
    },
    /**
     * 获取行数据
     */
    getRecordData: function getRecordData(value) {
      var option = this.getOption(value);
      return option && option.data || {};
    },
    /**
     * 获取选中行数据，单选为对象，多选为数组
     */
    getSelectedRows: function getSelectedRows() {
      var value = this.value;
      if (this.multiple) {
        return [];
      }
      var option = this.getOption(value);
      return option && option.data || {};
    },
    handleClearClick: function handleClearClick() {
      var _Select$methods$handl,
        _this6 = this;
      (_Select$methods$handl = _elementUi.Select.methods.handleClearClick).call.apply(_Select$methods$handl, [this].concat(Array.prototype.slice.call(arguments)));
      if (this.focusOnClear) {
        this.$nextTick(function () {
          return _this6.focus();
        });
      }
    },
    toggleDropMenu: function toggleDropMenu() {
      if (this.visible && this.disableClickHideMenu) {
        return;
      }
      this.toggleMenu();
    },
    handleFocus: function handleFocus(e) {
      var _Select$methods$handl2;
      if (this.focusSelect) {
        e.target.select();
      }
      (_Select$methods$handl2 = _elementUi.Select.methods.handleFocus).call.apply(_Select$methods$handl2, [this].concat(Array.prototype.slice.call(arguments)));
    },
    /**
     * 对 this.options 重新进行排序
     */
    sortOptions: function sortOptions() {
      var _this7 = this;
      var options = this.options,
        list = this.list;
      if (!(options && list)) {
        return;
      }
      this.options = this.list.map(function (item) {
        return options.find(function (o) {
          return o.data === item;
        });
      });
      if (this.options.length) {
        this.hoverOption = this.options[this.hoverIndex];
        this.options.forEach(function (option, i) {
          if (option) {
            option.hover = option === _this7.hoverOption;
          }
        });
      }
    }
  }
};